import template from 'lodash/template';
import { ajaxSend } from '../../../api/api';
const getPath = template('/v2/queues/${queueId}/teams');
const deletePath = template('/v2/queues/${queueId}/teams/${teamId}');
export function getQueueTeams(queueId, params = {}) {
    return ajaxSend({
        path: getPath({ queueId }),
        params: params,
    });
}
export function addTeamsToQueue(queueId, teamIds) {
    const deconstTeamIds = teamIds.map((id) => {
        return {
            team_id: id,
        };
    });
    return ajaxSend({
        path: getPath({ queueId }),
        method: 'PUT',
        data: { teams: deconstTeamIds },
    });
}
export function updateQueueTeams(queueId, teams) {
    return ajaxSend({
        path: getPath({ queueId }),
        method: 'PUT',
        data: {
            teams,
        },
    });
}
export function removeQueueTeams(queueId, teamIds) {
    /* Backend and UI only supports removing 1 team at a time,
       but to keep HOC api consistent we performing multiple request */
    const requests = teamIds.map((teamId) => {
        return ajaxSend({
            method: 'DELETE',
            path: deletePath({ queueId, teamId }),
        });
    });
    return Promise.all(requests);
}
